module.exports = __webpack_public_path__ + "fonts/fa-regular-400.b20db44b.ttf";